<template>

    <router-link class='footer-icon' to="/">
        Powered by
        <img src='@/assets/menulingua_logo_final.svg' />
    </router-link>

</template>

<script>

export default {
    name: 'Footer'
}


</script>

<style scoped>

.footer-icon {
    height: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0px 30px 0px 30px;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 2px;
    text-transform: uppercase;
    border-top: 1px solid lightgray;
    margin-top: 100px;
}

.footer-icon img {
    width: 200px;
    margin-left: 5px;
}

@media(max-width: 500px) {
    .footer-icon {
        font-size: 10px;
    }
}


</style>